import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	View,
	Platform,
	StyleSheet
} from "react-native";

import StyledButton from "ae-base/Base/StyledButton";
import StyledText from "ae-base/Base/StyledText";
import Style from "ae-style";
import InputContainer from "../Inputs/Layout/InputContainer";
import InputLabel from "../Inputs/Layout/InputLabel";

import ResponsiveStylesheet from "react-native-responsive-stylesheet";

const TRIANGLE_SIZE = 15

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		alignCenter: {
			alignItems: "center"
		},
		circleButton: {
			justifyContent: "center",
			alignItems: "center",
			paddingHorizontal: 2,
			paddingVertical: 4,
			marginHorizontal: 2
		},
		selectedButton: {
			backgroundColor: Style.colors.primary,
		},
		arrowDown: {
			width: 0,
			height: 0,
			borderLeftWidth: 8,
			borderRightWidth: 8,
			borderTopWidth: 8,
			borderStyle: "solid",
			borderLeftColor: "transparent",
			borderRightColor: "transparent"
		},
		arrowDownPrimary: {
			borderTopColor: Style.colors.primary,
		},
		arrowDownAlert: {
			borderTopColor: Style.colors.alert,
		},
		cursorRadius: {
			overflow: "hidden",
			borderRadius: 12,
		},
		textCenter: {
			textAlign: "center"
		},
		rowSpace: {
			flexDirection: "row",
			justifyContent: "space-between",
		},
		values: {
			paddingHorizontal: 4,
			paddingVertical: 8 + TRIANGLE_SIZE,
			flex: 8,
			width: "100%",
			position: "relative"
		},
		label: {
			flex: 1,
			width: "100%"
		},
		labelRight: {
			alignItems: "flex-end"
		},
		labelText: {
			width: "70%"
		},
		labelTextRight: {
			textAlign: "right"
		},
		rangeContainer: {
			flex: 1,
			alignItems: "center"
		},
		frameContainer:{
			height: "100%",
			aspectRatio: 1,
			position: "absolute",
			width: Platform.OS === "web" ? "10%" : undefined,
			top: 0
		},
		frame: {
			flexGrow:1,
			borderWidth: 4,
			borderColor: Style.colors.primary,
		},
		frameLeft: {
			borderTopWidth: 0,
			borderRightWidth: 0
		},
		frameRight: {
			borderBottomWidth: 0,
			borderLeftWidth: 0
		},
		valueContainer: {
			position: "relative",
			width: "100%"
		}
	},
	512: {
		circleButton: {
			paddingHorizontal: 8
		},
		values: {
			paddingHorizontal: 14
		},
		labelText: {
			width: "30%"
		}
	}
});

var SCALE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const triangleStyles = StyleSheet.create({
	triangleCorner: {
		width: 0,
		height: 0,
		backgroundColor: 'transparent',
		borderStyle: 'solid',
		borderRightWidth: TRIANGLE_SIZE,
		borderTopWidth: TRIANGLE_SIZE,
		borderRightColor: 'transparent',
		borderTopColor: Style.colors.primary
	},
	topLeft: {
		transform: [{ rotate: '270deg' }]
	},
	bottomRight: {
		transform: [{ rotate: '90deg' }],
		marginTop:"auto",
		marginLeft:"auto"
	}
})
export default class OutputRange extends Component {

	render() {
		var props = this.props;
		var context = this.context;
		var localize = context.localize;
		var localizeFrom = context.localizeFrom;
		var low = localize("atouchawayreminder.low");
		var high = localize("atouchawayreminder.high");
		var schema = props.schema;
		var rightLabel = schema.rightLabel;
		var leftLabel = schema.leftLabel;
		var scale = schema.enum || SCALE;

		var value = props.data

		var renderRightLabel = null;
		var renderLeftLabel = null;

		var leftLabelText = leftLabel ? localizeFrom(leftLabel.localization, ".") : "";
		var rightLabelText = rightLabel ? localizeFrom(rightLabel.localization, ".") : "";

		if (!leftLabel && !rightLabel) {
			leftLabelText = low;
			rightLabelText = high
		}

		if (leftLabelText) {
			renderLeftLabel = (
				<View style={styles.label}>
					<StyledText light style={styles.labelText}>{leftLabelText}</StyledText>
				</View>
			);
		}
		if (rightLabelText) {
			renderRightLabel = (
				<View style={[styles.label, styles.labelRight]}>
					<StyledText light style={[styles.labelText, styles.labelTextRight]}>{rightLabelText}</StyledText>
				</View>
			);
		}

		var renderTopButtons = (leftLabel || rightLabel) ? null : (
			<View style={styles.rowSpace}>
				<ScaleCursor title={low} contrast />
				<ScaleCursor title={high} alert />
			</View>
		);


		var renderScaleButtons = scale.map(function (number) {
			var selected = number === value;
			return <NumberButton id={props.id + "_" + number} key={number} number={number} selected={selected} />;
		});

		const frameLeft = <View style={[styles.frameContainer, {left:0}]}><View style={[triangleStyles.triangleCorner, triangleStyles.topLeft]} /><View style={[styles.frame, styles.frameLeft]}></View></View> 
		const frameRight = <View style={[styles.frameContainer, {right:0}]}><View style={[styles.frame, styles.frameRight]}></View><View style={[triangleStyles.triangleCorner, triangleStyles.bottomRight]} /></View>
		return (
			<InputContainer>
				<InputLabel contrast={props.contrast} schema={schema} />
				<View style={styles.rangeContainer}>
					{renderLeftLabel}
					<View style={styles.valueContainer}>
						{renderLeftLabel && frameLeft}
						<View style={[styles.rowSpace, styles.values]}>
							{renderScaleButtons}
						</View>
						{renderLeftLabel && frameRight}
					</View>
					{renderRightLabel}
				</View>
			</InputContainer>
		);
	}
}

function NumberButton(props, context) {
	var number = props.number;
	var selected = props.selected;
	var contrast = false;
	var id = props.id;

	var styleList = [styles.circleButton];

	if (selected) {
		styleList.push(styles.selectedButton);
		contrast = true;
	}

	return (
		<View id={context.id_prefix + id} style={styleList}>
			<View style={styles.textCenter}>
				<StyledText bold primary light contrast={contrast} smallHeading>{number}</StyledText>
			</View>
		</View>
	);
}

NumberButton.contextTypes = {
	id_prefix: PropTypes.string,
};

function ScaleCursor(props) {
	var title = props.title;
	var alert = props.alert;
	var contrast = props.contrast;
	var styleList = [styles.arrowDown];
	if (alert) {
		alert = true;
		contrast = false;
		styleList.push(styles.arrowDownAlert);
	}
	if (contrast) {
		alert = false;
		contrast = true;
		styleList.push(styles.arrowDownPrimary);
	}
	return (
		<View style={styles.alignCenter}>
			<View style={styles.cursorRadius}>
				<StyledButton title={title} bold contrast={contrast} alert={alert} />
			</View>
			<View style={styleList} />
		</View>
	);
}

OutputRange.contextTypes = {
	localize: PropTypes.func,
	localizeFrom: PropTypes.func
};